
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CodigoDescuento } from 'src/app/model/codigoDescuento';



const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  @Injectable({
    providedIn: 'root'
  })
  export class CodigoDescuentoService {
    private url : string = `${environment.HOST}/api/codigo-descuento`;
  


    constructor(
        private http : HttpClient,
        private router : Router
      ) { }

   

   
    
      
    
  nuevoRegistro( descripcion : string, porcentaje : number,idUsuario : number,) {
    return this.http.post(`${this.url}/nuevo-codigo-descuento/${descripcion}/${porcentaje}/${idUsuario}`, "");
  }

      
  eliminaRegistro( idCodigoDescuento : number,idUsuario : number,) {
    return this.http.post(`${this.url}/elimina-codigo-descuento/${idCodigoDescuento}/${idUsuario}`, "");
  }


  getAllCodigoDescuento():Observable<CodigoDescuento[]>{
    return this.http.get<CodigoDescuento[]>(`${this.url}/by-all`);
  }


    }